export default (method) => {
  if (/complete|interactive|loaded/.test(document.readyState)) {
    method();
  } else {
    $(document).ready(method);
  };
};
